import { validateTMVTest, TMV_APPLICATION_LIMITS } from '../../utils/plumbing/g3Calculations';

export const validator = {
  validate: (formData) => {
    const errors = {};
    const warnings = {};

    const {
      testerDetails = {},
      premisesDetails = {},
      valveSpecification = {},
      temperatureReadings = {},
      failSafeTesting = {},
      summaryAndDeclarations = {}
    } = formData;

    if (!testerDetails.companyName?.trim()) {
      errors['testerDetails.companyName'] = 'Testing company name is required';
    }
    if (!testerDetails.engineerName?.trim()) {
      errors['testerDetails.engineerName'] = 'Engineer name is required';
    }
    if (!premisesDetails.siteName?.trim()) {
      errors['premisesDetails.siteName'] = 'Premises / facility name is required';
    }
    if (!valveSpecification.valveTagNumber?.trim()) {
      errors['valveSpecification.valveTagNumber'] = 'Valve Asset / Tag ID is required';
    }

    // Dynamic TMV Application Validation
    const appKey = valveSpecification.applicationKey || 'tmv3_washbasin';
    const mixedTemp = Number(temperatureReadings.setMixedOutletTempC) || 0;
    const shutOffTime = Number(failSafeTesting.failSafeResponseTimeSec) || 0;

    const tmvCheck = validateTMVTest(appKey, mixedTemp, shutOffTime);
    if (!tmvCheck.pass) {
      tmvCheck.issues.forEach((msg, idx) => {
        if (msg.includes('temperature')) {
          errors['temperatureReadings.setMixedOutletTempC'] = msg;
        } else {
          errors['failSafeTesting.failSafeResponseTimeSec'] = msg;
        }
      });
    }

    // Hot & Cold supply checks
    const hotSupply = Number(temperatureReadings.hotSupplyTempC) || 0;
    const coldSupply = Number(temperatureReadings.coldSupplyTempC) || 0;

    if (hotSupply < 50) {
      warnings['temperatureReadings.hotSupplyTempC'] = `Hot supply (${hotSupply}°C) is below recommended 50°C minimum for legionella prevention and TMV delta T.`;
    }
    if (coldSupply > 20) {
      warnings['temperatureReadings.coldSupplyTempC'] = `Cold supply (${coldSupply}°C) exceeds 20°C standard maximum.`;
    }

    if (!summaryAndDeclarations.engineerSignature) {
      errors['summaryAndDeclarations.engineerSignature'] = 'Engineer signature is required';
    }

    return {
      isValid: Object.keys(errors).length === 0,
      errors,
      warnings
    };
  }
};

export default validator;
